$(document).ready(function () {
    //Call Menu Hover submenu
    //jQuery("div#header_menu_div .nav-bar__top-nav .nav-pills>li").hover(function(){
    jQuery('body').on('hover', 'div#header_menu_div .nav-bar__top-nav .nav-pills>li', function () {
        jQuery(this).addClass("gm-active");

    });

    jQuery('body').on('click', 'div#header_menu_div .nav-bar__top-nav .nav-pills>li', function () {
        $("div#header_menu_div .nav-bar__top-nav .nav-pills>li").each(function () {
            jQuery(this).removeClass("gm-active");
        });
        jQuery(this).addClass("gm-active");
    });

    jQuery('body').on('click', '.mobile-menu.mobile-menu-child button.alt-focus.mobile-menu-sub.mobile-menu-link', function () {
        if ($(this).closest("li").hasClass("open_child_tab")) {
            $(this).closest("li").removeClass("open_child_tab");
            $(this).find("svg").remove();
            $(this).append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.14209 5.44948L7.57797 12.1532L7.99923 12.5713L8.42049 12.1526L14.8564 5.44887L14.0139 4.57129L7.99923 10.8387L1.98461 4.57373L1.14209 5.44948Z" fill="#D8EFE0"/></svg>');
            $(this).closest("li").addClass("close_child_menu");
        } else {
            $(this).closest("li").removeClass("close_child_menu");
            $(this).closest("li").addClass("open_child_tab");
            $(this).find("svg").remove();
            $(this).append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.14209 10.5505L7.57797 3.84678L7.99923 3.42871L8.42049 3.84739L14.8564 10.5511L14.0139 11.4287L7.99923 5.16132L1.98461 11.4263L1.14209 10.5505Z" fill="#D8EFE0"/></svg>');

        }
    });

    jQuery('body').on('click', 'button.alt-focus.mobile-menu-link.mobile-menu-sub.mobile-menu-link__text', function () {
        // console.log("click main menu for mobile");
      console.log($(this).closest("li").parent(), 'sdsd')
        if ($(this).closest("li").hasClass("open_tab")) {
            $(this).closest("li").removeClass("open_tab");
            $(this).closest("li").parent().removeClass("tab_open");
            $(this).find("svg").html('<path d="M5.44972 1.14209L12.1535 7.57797L12.5715 7.99923L12.1529 8.42049L5.44911 14.8564L4.57153 14.0139L10.8389 7.99923L4.57397 1.98461L5.44972 1.14209Z" fill="#D8EFE0"/>');

            $(this).closest("li").addClass("closemenu");
            setTimeout(function () {
                $(this).closest("li").find(".mobile-menu").removeClass("active");
                $(this).closest("li").find(".mobile-menu").removeClass("active");
            }, 1000);


        } else {
            $(this).closest("li").removeClass("closemenu");
            $(this).closest("li").addClass("open_tab");
            $(this).closest("li").parent().addClass("tab_open");

            $(this).find("svg").html('<path d="M10.5503 1.14209L3.84654 7.57797L3.42847 7.99923L3.84715 8.42049L10.5509 14.8564L11.4285 14.0139L5.16108 7.99923L11.426 1.98461L10.5503 1.14209Z" fill="#D8EFE0"/>');

        }


    });
    setTimeout(function () {
        $('div#product-recommendations-wrapper').slick({
            dots: false,
            infinite: false,
            arrows: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $("div#product-recommendations-wrapper .grid__item").each(function (index) {
            // Your code
            var wishhtml = '<div><button aria-label="Add to wishlist" title="Add to wishlist" class="" style="color: rgb(55, 73, 63); background: rgb(216, 239, 224); border-radius: 100%; margin: 0px; opacity: 0.9; border: none; line-height: normal; height: 40px; display: block; padding: 0px 20px; font-size: 14px; text-align: center; overflow: hidden; outline: none; position: relative; cursor: pointer;"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="#37493F"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg></button></div>';
            $(this).find(".wishlist-hero-custom-button.wishlisthero-floating").html(wishhtml);
        });

    }, 2000);

    $('div#mobile_cover_img').slick({
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        slidesToScroll: 1,
        asNavFor: 'div#mobile_thumb_img',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                dots: true,

                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('div#mobile_thumb_img').slick({
        dots: false,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        touchThreshold: 5,
        focusOnSelect: true,
        asNavFor: 'div#mobile_cover_img',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,

                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,

                }
            }
        ]
    });


    $('.slider--product_img').slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        slidesToScroll: 1,
        asNavFor: '.gallery__thumbnails_img',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                dots: true,

                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
  console.log('called', $('.gallery__thumbnails_img').length)
    $('.gallery__thumbnails_img').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: false,
        focusOnSelect: true,
        asNavFor: '.slider--product_img',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,

                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,

                }
            }
        ]
    });

  setTimeout(function() {
    
  if ($('.gallery__thumbnails_img.slick-initialized .slick-arrow').length <= 0) {
      $('.gallery__thumbnails_img.slick-initialized .slick-track').addClass('no-swipe');
  } else {
      $('.gallery__thumbnails_img.slick-initialized .slick-track').removeClass('no-swipe');
  }
    if ($('.gallery__thumbnails_img.slick-initialized .slick-arrow').length <= 0) {
      $('#mobile_thumb_img .slick-track').addClass('no-swipe');
  } else {
      $('#mobile_thumb_img .slick-track').removeClass('no-swipe');
  }
      
  }, 2000);
});